import {AxiosError} from 'axios'
import {UseMutationOptions} from 'react-query'

import {API} from '../../../networking/http'
import {SubscriptionFormType} from '../../../services/subscription/forms/subscription-purchase-form'

export type PaySubscriptionForPayParams = {
  draft: SubscriptionFormType['subscriptionDraft'],
  entityId: SubscriptionFormType['subscriptionBookingId'],
  totalPrice: SubscriptionFormType['totalPrice']
}
export type PaySubscriptionForPayOptions = NonNullable<PaySubscriptionForPayParams>;

export type PaySubscriptionForPayQueryReturnType = undefined

export const paySubscriptionForPayEndpoint = 'payments/entityForPay'

export type PaySubscriptionByOneTimePaymentMuOp = UseMutationOptions<
  PaySubscriptionForPayQueryReturnType,
  AxiosError,
  PaySubscriptionForPayOptions
>

export const paySubscriptionByOneTimePayment = (params?: PaySubscriptionByOneTimePaymentMuOp): PaySubscriptionByOneTimePaymentMuOp => {
  return ({
    mutationFn: async (options: PaySubscriptionForPayOptions) => {
      if (!options.totalPrice) {
        return Promise.resolve(undefined)
      }
      const res = await API.post<PaySubscriptionForPayOptions, PaySubscriptionForPayQueryReturnType>(
        paySubscriptionForPayEndpoint,
        {
          collection: 'membershipsBookingsForPay',
          draft: options.draft,
          entityId: options.entityId,
        })
      return res.data
    },
    ...params
  })
}

